export function setToLocalStorage(storageName, value) {
  if (typeof window !== "undefined" && localStorage) {
    try {
      const storedValue =
        typeof value === "string" ? value : JSON.stringify(value);
      localStorage.setItem(storageName, storedValue);
    } catch (error) {
      console.error("Error saving to localStorage:", error);
    }
  } else {
    console.error("localStorage is not available.");
  }
}

export function removeFromLocalStorage(storageName) {
  if (typeof window !== "undefined" && localStorage) {
    try {
      localStorage.removeItem(storageName);
    } catch (error) {
      console.error("Error removing from localStorage:", error);
    }
  } else {
    console.error("localStorage is not available.");
  }
}

export function getFromLocalStorage(storageName) {
  if (typeof window !== "undefined" && localStorage) {
    try {
      const storedValue = localStorage.getItem(storageName);

      // If storedValue is "true" or "false", return as boolean
      if (storedValue === "true") return true;
      if (storedValue === "false") return false;

      // Check if it's JSON or plain text
      if (
        storedValue &&
        (storedValue.startsWith("{") || storedValue.startsWith("["))
      ) {
        return JSON.parse(storedValue); // Parse if it's valid JSON
      }

      return storedValue; // Return as is if it's plain text
    } catch (error) {
      console.error("Error reading from localStorage:", error);
      return null;
    }
  } else {
    console.error("localStorage is not available.");
    return null;
  }
}
